module.exports = __webpack_public_path__ + "img/PaymentCN.7d7812ad.png";